import { sourceProvider } from '../../../core/SourceProvider.ts';
import { sourceHttpClient } from '../../../core/SourceHttp.ts';
import { createAnimeSource } from '../../../anime/AnimeRepository.ts';
import type { AnimeTitle } from '../../../anime/types.ts';
import type { YomiriManga } from '../../../types/extension.ts';
import type { HomeMedia, MediaKind } from '../../../metadata/HomeRecommendations.ts';

export type RecommendationResult = YomiriManga | AnimeTitle;
const searches = new Map<string, { until: number; job: Promise<RecommendationResult[]> }>();
export const normalizedTitle = (value: string) => value.normalize('NFKD').replace(/\p{M}/gu, '').toLowerCase().replace(/[^\p{L}\p{N}]/gu, '');
/** Label title similarity; this does not assert that an edition is the same work. */
export function recommendationMatch(result: RecommendationResult, item: HomeMedia): number {
  const title = normalizedTitle(result.title);
  const aliases = [item.title.romaji, item.title.english, item.title.native, ...(item.synonyms || [])].filter((value): value is string => !!value).map(normalizedTitle);
  if (aliases.includes(title)) return 3;
  if (aliases.some(alias => alias.length >= 4 && (title.includes(alias) || alias.includes(title)))) return 2;
  return 0;
}
export function recommendationQueries(item:HomeMedia, preferred:string):string[]{
  const seen=new Set<string>();
  return [preferred,item.title.english,item.title.romaji,...(item.synonyms||[]),item.title.native]
    .filter((value):value is string=>!!value?.trim())
    .filter(value=>{const key=normalizedTitle(value);if(!key||seen.has(key))return false;seen.add(key);return true;}).slice(0,4);
}
export function searchRecommendation(kind: MediaKind, sourceId: string, query: string): Promise<RecommendationResult[]> {
  const key = `${kind}:${sourceId}:${query.trim().toLowerCase()}`;
  const cached = searches.get(key);
  if (cached && cached.until > Date.now()) return cached.job;
  if (searches.size >= 60) searches.delete(searches.keys().next().value!);
  let timer: ReturnType<typeof setTimeout> | undefined;
  const request = kind === 'MANGA' ? sourceProvider.search(sourceId, query.trim(), 1).then(page => page.mangas) : createAnimeSource(sourceId, sourceHttpClient).search(query.trim()).then(page => page.titles);
  const job = Promise.race([request, new Promise<never>((_, reject) => { timer = setTimeout(() => reject(new Error('Esta fuente está tardando demasiado.')), 8000); })]).finally(() => clearTimeout(timer));
  searches.set(key, { until: Date.now() + 10 * 60000, job });
  void job.catch(() => { if (searches.get(key)?.job === job) searches.delete(key); });
  return job;
}
